import { mode } from "@chakra-ui/theme-tools";
export const inputStyles = {
  components: {
    Input: {
      baseStyle: {
        field: {
          fontWeight: 400,
          borderRadius: "0.5rem",
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: mode("transparent", "rgba(17, 24, 39, 0.5)")(props),
            border: "1px solid",
            color: mode("secondaryGray.900", "gray.200")(props),
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            fontSize: "sm",
            p: "20px",
            _placeholder: { color: mode("secondaryGray.400", "gray.600") },
            _focus: {
              borderColor: mode("secondaryGray.100", "gray.600")(props),
            },
          },
        }),
        auth: (props) => ({
          field: {
            fontWeight: "500",
            color: mode("navy.700", "white")(props),
            bg: mode("transparent", "transparent")(props),
            border: "1px solid",
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            _placeholder: { color: mode("secondaryGray.600", "gray.600"), fontWeight: "400" },
            _focus: {
              borderColor: mode("secondaryGray.100", "gray.600")(props),
            },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: "transparent",
            border: "1px solid",
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
            _focus: {
              borderColor: mode("secondaryGray.100", "gray.600")(props),
            },
          },
        }),
        search: (props) => ({
          field: {
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
          },
        }),
        filled: (props) => ({
          field: {
            bg: mode("gray.100", "gray.700")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "gray.600")(props),
            color: mode("secondaryGray.900", "white")(props),
            borderRadius: "0.5rem",
            fontSize: "sm",
            _placeholder: { color: mode("gray.500", "gray.400") },
            _hover: {
              bg: mode("gray.100", "gray.700")(props),
            },
            _focus: {
              bg: mode("white", "gray.600")(props),
              borderColor: mode("brand.500", "brand.400")(props),
            },
            _disabled: {
              opacity: 0.6,
              cursor: "not-allowed",
            },
          },
        }),
      },
    },
    NumberInput: {
      baseStyle: {
        field: {
          fontWeight: 400,
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: "transparent",
            border: "1px solid",
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
          },
        }),
        auth: (props) => ({
          field: {
            bg: "transparent",
            border: "1px solid",
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: "transparent",
            border: "1px solid",
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
          },
        }),
        search: (props) => ({
          field: {
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
          },
        }),
      },
    },
    Select: {
      baseStyle: {
        field: {
          fontWeight: 400,
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: mode("transparent", "rgba(17, 24, 39, 0.5)")(props),
            border: "1px solid",
            color: mode("secondaryGray.600", "gray.200")(props),
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
            _focus: {
              borderColor: mode("secondaryGray.100", "gray.600")(props),
            },
          },
          icon: {
            color: mode("secondaryGray.600", "gray.600"),
          },
        }),
        mini: (props) => ({
          field: {
            bg: mode("transparent", "rgba(17, 24, 39, 0.5)")(props),
            border: "0px solid transparent",
            fontSize: "0px",
            p: "10px",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
          },
          icon: {
            color: mode("secondaryGray.600", "gray.600"),
          },
        }),
        subtle: (props) => ({
          box: {
            width: "unset",
          },
          field: {
            bg: "transparent",
            border: "0px solid",
            color: mode("secondaryGray.600", "gray.400")(props),
            borderColor: "transparent",
            width: "max-content",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
          },
          icon: {
            color: mode("secondaryGray.600", "gray.600"),
          },
        }),
        transparent: (props) => ({
          field: {
            bg: "transparent",
            border: "0px solid",
            width: "min-content",
            color: mode("secondaryGray.600", "gray.400")(props),
            borderColor: "transparent",
            padding: "0px",
            paddingLeft: "8px",
            paddingRight: "20px",
            fontWeight: "700",
            fontSize: "14px",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
          },
          icon: {
            transform: "none !important",
            position: "unset !important",
            width: "unset",
            color: mode("secondaryGray.600", "gray.600"),
            right: "0px",
          },
        }),
        auth: (props) => ({
          field: {
            bg: "transparent",
            border: "1px solid",
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
            _focus: {
              borderColor: mode("secondaryGray.100", "gray.600")(props),
            },
          },
        }),
        authSecondary: (props) => ({
          field: {
            bg: "transparent",
            border: "1px solid",
            borderColor: mode("secondaryGray.100", "gray.700")(props),
            borderRadius: "0.5rem",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
            _focus: {
              borderColor: mode("secondaryGray.100", "gray.600")(props),
            },
          },
        }),
        search: (props) => ({
          field: {
            border: "none",
            py: "11px",
            borderRadius: "inherit",
            _placeholder: { color: mode("secondaryGray.600", "gray.600") },
          },
        }),
        filled: (props) => ({
          field: {
            bg: mode("gray.100", "gray.700")(props),
            border: "1px solid",
            borderColor: mode("gray.200", "gray.600")(props),
            color: mode("secondaryGray.900", "white")(props),
            borderRadius: "0.5rem",
            _placeholder: { color: mode("gray.500", "gray.400") },
            _hover: {
              bg: mode("gray.100", "gray.700")(props),
            },
            _focus: {
              bg: mode("white", "gray.600")(props),
              borderColor: mode("brand.500", "brand.400")(props),
            },
          },
          icon: {
            color: mode("secondaryGray.600", "gray.400"),
          },
        }),
      },
    },
    // PinInputField: {
    //   variants: {
    //     main: (props) => ({
    //       field: {
    //         bg: "red !important",
    //         border: "1px solid",
    //         color: mode("secondaryGray.900", "white")(props),
    //         borderColor: mode("secondaryGray.100", "whiteAlpha.100")(props),
    //         borderRadius: "16px",
    //         _placeholder: { color: "secondaryGray.600" },
    //       },
    //     }),
    //   },
    // },
  },
};
